<div class="row">
    <div class="col-4 offset-lg-2 col-lg-3">
        <label for="appointment-date">{{ row.getFormattedDate() }}</label>
    </div>
    <div class="col-3">
        <label for="appointment-time">{{ row.getFormattedTime() }}</label>
    </div>
    <div class="col-4 col-lg-3">
        @if (row.isLoading) {
            <progressbar [striped]="true" [value]="100">
                {{ 'CONFIRMATION_FOLLOWUP_BOOKING_APPOINTMENT_LABEL' | translate }}
            </progressbar>
        } @else if (row.status === APPOINTMENT_SLOT_STATUS.NOT_AVAILABLE) {
            @if (isMobile$ | async) {
                <fa-icon [icon]="faBan"></fa-icon>
            } @else {
                <span [translate]="'CONFIRMATION_FOLLOWUP_BOOKING_APPOINTMENT_NOT_CONFIRMED_LABEL'"></span>
            }
        } @else {
            <button class="btn btn-primary" type="button" [disabled]="row.disabled" (click)="selectSlot()">
                @if (isMobile$ | async) {
                    {{ 'CONFIRMATION_FOLLOWUP_BOOK_APPOINTMENT_SHORT_LABEL' | translate }}
                } @else {
                    {{ 'CONFIRMATION_FOLLOWUP_BOOK_APPOINTMENT_LABEL' | translate }}
                }
            </button>
        }
    </div>
</div>
